// extracted by mini-css-extract-plugin
module.exports = {"container":"Pay_style_container__UjsAL","tip":"Pay_style_tip__3n4tY","category":"Pay_style_category__1NgvA","item":"Pay_style_item__1DtNI","pay":"Pay_style_pay__3sUk2"};